import type { Student } from "../providers/studentsProvider";
import type { DialogProps } from "../misc/DialogProps";

import { CheckboxGroupInput, EditBase, Form } from "react-admin";
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { DrivingSchool } from "../providers/drivingSchoolsProvider";
import _sortBy from "lodash/sortBy";
import { SaveButton2 } from "../buttons/SaveButton2";

export function StudentTheoryBranchesDialog({
  drivingSchool,
  student,
  ...dialogProps
}: {
  drivingSchool: DrivingSchool;
  student: Student;
} & DialogProps) {
  const { onClose: closeDialog } = dialogProps;

  return (
    <Dialog {...dialogProps}>
      <DialogTitle>Theorieunterricht für {student.name}</DialogTitle>
      <DialogCloseButton onClick={closeDialog} />
      <EditBase mutationMode="pessimistic" redirect={false} mutationOptions={{ onSuccess: closeDialog }}>
        <Form>
          <DialogContent>
            <CheckboxGroupInput
              source="theoryBranches"
              label={
                <Typography
                  sx={{
                    fontSize: /* we want 14px, but the <legend> element is scaled by 0.75, therefore: */ "18.6667px",
                  }}
                >
                  kann hier gebucht werden:
                </Typography>
              }
              choices={_sortBy(drivingSchool.branches, (branch) => branch.name).map((branch) => ({
                id: branch.uid,
                name: branch.name,
              }))}
              row={false}
            />
          </DialogContent>
          <DialogActions>
            <SaveButton2 />
          </DialogActions>
        </Form>
      </EditBase>
    </Dialog>
  );
}
